<ng-container *ngIf="loading">
  <app-spinner></app-spinner>
</ng-container>

<ng-container *ngIf="!loading">
  <div class="img-wrapper">
    <app-zaver-icon [size]="88" name="diamond" ></app-zaver-icon>
  </div>
  <div class="text">
    The order is now awaiting your payment. You can pay using the details below.
    An invoice has also been sent to your email {{ email }}
  </div>

  <div class="info-wrapper">
    <div style="font-size: 14px; font-weight: 700; margin-bottom: 16px">
      Your purchase
    </div>
    <hr class="details-divider" />
    <div class="details-container">
      <div class="details-key-entry">{{ state.paymentInformation?.title }}</div>
      <div class="details-value-entry">
        <zaver-button-link
          [text]="'Details'"
          (click)="toggleModal()"
        ></zaver-button-link>
      </div>
    </div>
    <hr class="details-divider" />

    <div style="font-size: 14px; font-weight: 700; margin-top: 36px">
      Instructions
    </div>

    <div class="details-container">
      <div class="details-key-entry">Recipient</div>
      <div class="details-value-entry details">Zaver - Frink AB</div>
    </div>
    <hr class="details-divider" />

    <ng-container *ngIf="payInAdvancePaymentJson.paymentViban">
      <div class="details-container">
        <div class="details-key-entry">IBAN</div>
        <div class="details-value-entry details">
          {{ payInAdvancePaymentJson.paymentViban }}
        </div>
      </div>
      <hr class="details-divider" />
    </ng-container>

    <ng-container *ngIf="payInAdvancePaymentJson.bic">
      <div class="details-container">
        <div class="details-key-entry">BIC</div>
        <div class="details-value-entry details">
          {{ payInAdvancePaymentJson.bic }}
        </div>
      </div>
      <hr class="details-divider" />
    </ng-container>

    <ng-container *ngIf="payInAdvancePaymentJson.bankName">
      <div class="details-container">
        <div class="details-key-entry">Bank</div>
        <div class="details-value-entry details">
          {{ payInAdvancePaymentJson.bankName }}
        </div>
      </div>
      <hr class="details-divider" />
    </ng-container>

    <ng-container *ngIf="payInAdvancePaymentJson.paymentReference">
      <div class="details-container">
        <div class="details-key-entry">Reference</div>
        <div class="details-value-entry details">
          {{ payInAdvancePaymentJson.paymentReference }}
        </div>
      </div>
      <hr class="details-divider" />
    </ng-container>

    <ng-container *ngIf="state.totalCheckoutValue">
      <div class="details-container">
        <div class="details-key-entry">Amount to pay</div>
        <div class="details-value-entry details">
          {{ state.totalCheckoutValue | value }}
        </div>
      </div>
    </ng-container>

    <hr class="details-divider" />
  </div>

  <p
    style="
      text-align: center;
      color: #858e9c;
      font-size: 12px;
      margin: 32px 0px;
    "
  >
    An invoice with payment instructions has also been sent to your provided
    email address.
  </p>

  <div *ngIf="successUrl" class="pia-success-button-container">
    <zaver-button-link
      [text]="'Return to ' + state.checkoutCustomizations?.merchantName"
      (click)="onRouteToSuccessUrl()"
    ></zaver-button-link>
  </div>
</ng-container>

<zaver-checkout-modal
  *ngIf="selectorItems && modalActive"
  [buttonText]="'Close'"
  [title]="'View details'"
  (onClose)="toggleModal()"
>
  <app-selector #selector [selectorItems]="selectorItems"></app-selector>
</zaver-checkout-modal>
